module.exports = __webpack_public_path__ + "img/blue_164.e64819e5.png";